var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "white", attrs: { id: "login" } },
    [
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { attrs: { fluid: "", "fill-height": "" } },
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "", "justify-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm8: "", md4: "", lg4: "" } },
                    [
                      _c(
                        "v-toolbar",
                        { staticClass: "app-style", attrs: { dark: "" } },
                        [_c("v-toolbar-title", [_vm._v("Login form")])],
                        1
                      ),
                      _c(
                        "v-card",
                        { staticClass: "elevation-1 pa-3" },
                        [
                          _c("v-card-text", [
                            _c("div", { attrs: { id: "g_id_signin" } }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }